import { InitialConfigType } from "@lexical/react/LexicalComposer";

export function useInitialConfig() {
  const config: InitialConfigType = {
    namespace: "lexical-editor",
    theme: {},
    onError: (error) => {
      throw error;
    },
  };

  return config;
}
